import { AjaxCall } from 'api/basicApi';
import ApplicationEvents from 'components/applicationEvents';
import { LogStream } from 'generics/common';
import { SettingsInjections } from 'generics/settingsInjections';

LogStream.enable( "APICALLDEBUG" );

////////////////////////////////////////////
// class NickResolveAPI
class NickResolveAPI  extends AjaxCall {
  constructor( command )
  {
    super( command );

    let crd = SettingsInjections.getCredentials();

    this.command = command;

    this.appendHeader( "Authorization", "Bearer " + crd.token );
  }

  getInterfaceUrl()  {
    return SettingsInjections.getUsedCircuit().nickresolve_server + this.command;
  }
};

export function ResolveNickName( nickname )
{
  let callResolve = new NickResolveAPI( "/public/resolve/nicks" );
  //let callResolve = new NickResolveAPI( "/private/resolve/nicks" );

  callResolve.append("nicks", [ nickname ]);

  return callResolve.RPC().then(
    (resp) =>  {
      LogStream( "APICALLDEBUG" ).info(`ResolveNickName(${nickname}) - got response:`, resp);
      return resp.result[nickname];
    },
    ( reason ) =>  {
      ApplicationEvents.emit_async("auth.tokenExpired");
      return Promise.reject( reason );
    }
  );
}

export function ResolveUid( uid )
{
  let callResolve = new NickResolveAPI( "/public/resolve/uids" );
  //let callResolve = new NickResolveAPI( "/private/resolve/uids" );

  callResolve.append("ids", [ parseInt(uid) ]);

  return callResolve.RPC().then(
    ( resp ) =>  {
      LogStream( "APICALLDEBUG" ).info(`ResolveUid(${uid}) - got response:`, resp);
      return resp.result[uid];
    },
    ( reason ) =>  {
      ApplicationEvents.emit_async("auth.tokenExpired");
      return Promise.reject( reason );
    }
  );
}
